import React from "react";

import { Title, MultiplyIcon } from "shared/components";
import { Spacer } from "shared/layout";
import { IStageCapacity } from "Venues/types";
import { copy } from "shared/assets";
import { MutedDarkText } from "shared/styles";
import { capacityTypeOptions } from "Venues/utils";

const { capacities: capacitiesCopy } = copy.stageProperties;

interface StageCapacitiesProps {
  capacities?: IStageCapacity[] | null;
}

export const StageCapacities: React.FC<StageCapacitiesProps> = ({ capacities }) => {
  return (
    <Spacer size="m">
      <Title asComponent="h3" size="s" title={capacitiesCopy.title} />
      <Spacer size="xs">
        {capacities?.map(({ title, capacity, type, id }) => (
          <Spacer size="xs" spaceDirection="horizontal" key={id}>
            <span>{title}</span>
            <MutedDarkText>
              <Spacer size="xxs" spaceDirection="horizontal" align="center">
                <span>{capacity}</span>
                <MultiplyIcon />
                <span>{capacityTypeOptions[type]}</span>
              </Spacer>
            </MutedDarkText>
          </Spacer>
        ))}
      </Spacer>
    </Spacer>
  );
};
